
@if( !isLoading ) {

	<div class="theForm">

		@for( question of questionTree; track question.id ) {

			@if( question.bIsVisible ) {

				<question
					[formGroup]="formGroup"
					[question]="question"
				/>

			}

		}

		<!--
		<div>
			{{formGroup.value | json}}
		</div>
		<div>
			{{ formGroup.valid ? "valid" : "INVALID" }}
		</div>
		-->

	</div>

	@if( formGroup ) {

		<div style="text-align: center;">
			<button
				mat-raised-button
				(click)="validate()"
				[disabled]="!formGroup.valid"
			>
				Bestätigen
			</button>
		</div>

	}

}
